import React from 'react'
import { Table, message, Card, Button } from 'antd'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import useServerPagination from 'Common/hooks/useServerPagination'

// Fetch a page of the mentor's progress reports.
const fetchReports = async ({ pageNumber, pageSize, orderByLatest }) => {
  const mentorId = localStorage.getItem('personalId')
  const token = localStorage.getItem('token')
  const response = await axios.get(
    `${process.env.REACT_APP_API_URL}/TrainingProgressReport/Mentor/${mentorId}`,
    {
      params: { pageNumber, pageSize, orderByLatest },
      headers: {
        Accept: '*/*',
        Authorization: `Bearer ${token}`,
      },
    },
  )
  return response.data
}

const ProgressReport = () => {
  const navigate = useNavigate()
  const { items, loading, paginationProps } = useServerPagination(fetchReports, {}, {
    onError: () => message.error('Failed to fetch data. Please try again.'),
  })

  const handleViewDetails = (reportId) => {
    navigate(`/progress-report-detail/${reportId}`)
  }

  const columns = [
    {
      title: 'Learner Name',
      dataIndex: 'learnerName',
      key: 'learnerName',
    },
    {
      title: 'Submission Date',
      dataIndex: 'createdOn',
      key: 'createdOn',
      render: (date) => new Date(date).toLocaleString(),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Button type="primary" onClick={() => handleViewDetails(record.id)}>
          View Details
        </Button>
      ),
    },
  ]

  return (
    <Card
      className="card-professional"
      loading={loading}
      title="Progress Report"
      extra={
        <Button type="default" onClick={() => navigate('/project-training')}>
          Back
        </Button>
      }
    >
      <Table
        columns={columns}
        dataSource={items}
        rowKey="id"
        pagination={paginationProps}
        scroll={{ x: "max-content" }}
      />
    </Card>
  )
}
export default ProgressReport
